// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__IMweT","footer":"ModalInfo_footer__sWpAS"};